import { t } from "i18next";
import { useEffect, useState } from "react"

export const CustomHelpText = ({ hidden, exist }) => {
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (exist === '' || exist === null || exist === undefined || exist === false) { // text || autocomplete => ''   // Calendar => null  // img => false
            setMessage(t('NotEmptyjavalangString'));
        } else {
            setMessage('');
        }
    }, [])

    return (
        <p hidden={!hidden}
            style={{
                color: 'red',
                fontSize: '10px',
                fontWeight: 600,
                lineHeight: 1.66,
                letterSpacing: "0.03333em",
                textAlign: 'left',
                marginTop: '4px',
                marginRight: '14px',
                marginBottom: '0px',
                marginLeft: '14px',
                fontFamily: 'sans-serif'
            }}>{message}</p>
    );
}